<div
  class="risk-spinner"
  [attr.data-cy]="'ui-loading'"
  [class.d-block]="display === 'block'"
  [class.d-inline]="display === 'inline'"
  [class.d-inline-block]="display === 'inline-block'"
  [class.risk-spinner-opaque]="opaque">
  @if (!legacySpinner) {
    <img alt="Loading spinner" [src]="'app/assets/img/circle_spinner.svg'" [width]="sizeMap[size]" />
  } @else {
    <!-- Uses fontawesome-->
    <i
      class="fa fa-spinner fa-spin"
      [class.fa-lg]="size === 'md'"
      [class.fa-2x]="size === 'lg'"
      [class.fa-3x]="size === 'xl'"></i>
  }
  <span [hidden]="display !== 'inline' || !text">{{ text }}</span>
  <p class="mb-0" [hidden]="display === 'inline' || !text" style="padding: 15px">{{ text }}</p>
</div>
